<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Kod Akaun">

            
               <!--  <w-flex justify-space-between class="mb4">
                    <z-lookup label="Jenis" name="jenis " :url='service_utiliti+"api/lookup/jenis_akaun"' :sort="false" :cache="false" v-model="cari.lkp_jenis_akaun_id"/>
                    &nbsp;&nbsp;
                </w-flex> -->
                <w-flex justify-space-between class="mb4">
                    <div class="xs4">
                        <z-lookup label="Jenis" name="jenis" :url='service_utiliti+"lookup/jenis_akaun"' :sort="false" :cache="false" v-model="cari.lkp_jenis_akaun_id" />
                    </div>
                    <div class="xs4">
                        <w-input label="Keterangan" v-model="cari.keterangan" name="Keterangan" />
                    </div>

                    <div class="xs4">
                        <w-input label="Kod" v-model="cari.kod" name="Kod" />
                    </div>
                </w-flex>

                <w-flex justify-space-between class="mb4">
                    <div class="xs4">
                       
                      <z-lookup label="Status" name="status" 
                        :options="[{label: 'AKTIF', value: 1}, {label: 'TIDAK AKTIF', value: 2}]" :sort="false" :cache="false" v-model="cari.status" />
                  </div>
              </w-flex>


            
            <div class="mt2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <w-dialog v-model="modal.show" :fullscreen="modal.fullscreen" :width="modal.width" :persistent="modal.persistent" :persistent-no-animation="modal.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Paparan Jejak Audit
                </template>
               <!--  <template #default>
                     <w-form ref="form" v-model="modal.valid" @validate="send" @success="success">

                                <table class="w-table">
                                    <thead>
                                    <tr>
                                        <th class="w-table__header w-table__header--sortable text-left">No</th>
                                        <th class="w-table__header w-table__header--sortable text-left">Tindakan</th>
                                        <th class="w-table__header w-table__header--sortable text-left">Pengguna</th>
                                        <th class="w-table__header w-table__header--sortable text-left">Tarikh</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    
                                        <tr v-for="dt, index in form.jejak_audit">
                                            <td class="w-table__cell text-left">
                                                {{(index + 1)}}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{dt.tindakan_keterangan}}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{dt.user_nama}}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{dt.tarikh}}
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                    
                                </table>
                        
                    </w-form>
                </template> -->
                    <z-jejak-audit :jejak_audit="form.jejak_audit"/>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="modal.show = false">Tutup</w-button>
                    
                        
                </template>
            </w-dialog>

    
            <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                
                <template #title>
                    <!-- <w-icon class="mr2">fal fa-cog</w-icon> -->
                    <template v-if="form.id">
                         Kemaskini Kod Akaun
                    </template>
                    <template v-else>
                         Tambah Kod Akaun
                    </template>
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">
                        <template v-if="form.akaun && form.akaun.kod"><br>

                            <tr>
                                  <th>Akaun Utama &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :</th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  <td>{{form.akaun.kod}} |</td>
                                  <td>{{form.akaun.keterangan}}</td>
                            </tr>
                            <br><br>
                          </template>
                        
                        <w-flex justify-space-between class="mb4">
                            <z-lookup label="Jenis *" name="jenis" :url='service_utiliti+"lookup/jenis_akaun"' :sort="false" :cache="false" v-model="form.lkp_jenis_akaun_id"/>
                            &nbsp;&nbsp;
                        </w-flex>
                         <w-flex justify-space-between class="mb4">
                            <z-lookup label="Vot *" name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="form.vot_id"/>
                            &nbsp;&nbsp;
                        </w-flex>

                       <!--  <w-flex justify-space-between class="mb4">
                            <z-lookup label="Profil *" name="profil" :url='service_utiliti+"api/lookup/profil"' :sort="false" :cache="false" v-model="form.profil_id"/>
                        </w-flex> -->

                        <w-flex justify-space-between class="mb4">
                            <z-input label="Kod *" v-model="form.kod" name="kod" :validators="[validators.required]" />
                        </w-flex>

                        <w-flex justify-space-between class="mb4">
                            &nbsp;&nbsp;
                            <z-input label="Keterangan *" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
                        </w-flex>

                        <!-- <w-flex justify-space-between class="mb4">
                            &nbsp;&nbsp;
                            <z-input  label="Akaun Asas" v-model="form.akaun_asas" name="Akaun Asas" :validators="[validators.required]" />
                        </w-flex> -->
                        <w-flex justify-space-between class="mb4">
                            <!-- <div class="xs4">
                                <h5 class="fw-semibold m0">
                                      Akaun Asas
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.akaun_asas"></w-switch>
                                </div>
                            </div> -->
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                      Aras Akhir
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.aras_akhir"></w-switch>
                                </div>
                            </div>

                        <template v-if="form.id">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                      Status
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.status"></w-switch>
                                </div>
                            </div>
                        </template>

                        </w-flex>
                       

                       <!--  <w-flex justify-space-between class="mb4">
                            &nbsp;&nbsp;
                            <z-input label="Aras Akhir" v-model="form.aras_akhir" name="Aras Akhir" :validators="[validators.required]" />
                        </w-flex> -->

                        
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                    <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">{{form.saveButton}}</w-button>
                </template>
            </w-dialog>

            <z-table ref="tbluser" title="Senarai Kod Akaun" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="add(null)">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.keterangan="{ item, label, header, index }">
                  <template v-if="item.level >= 2">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 3">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 4">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 5">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 6">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 7">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 8">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 9">&nbsp;&nbsp;&nbsp;</template>
                  <template v-if="item.level >= 10">&nbsp;&nbsp;&nbsp;</template>
                    {{item.kod}} | {{item.keterangan}} <template v-if="item.aras_akhir == 1"><b>(Aras Akhir)</b></template>
                    
                </template>
                 <template #item-cell.vot="{ item, label, header, index }">
                        {{item.vot_kod}} <template v-if="item.vot_kod != null">|</template> {{item.vot_keterangan}} 
                </template>

                <template #item-cell.status="{ item, label, header, index }">
                   
                    <template v-if="item.status == 1">
                        AKTIF
                    </template>
                    <template v-else>
                        TIDAK AKTIF
                    </template>
                </template>
                
                
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                            
                             <w-icon class="mr1" @click="add(item)">fal fa-plus</w-icon>  
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <w-icon tile @click="edit(item)">fal fa-pencil</w-icon> 
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                        <template v-if="item.level >= 2">
                            <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                        </template>
                        <template v-else>
                             &nbsp;&nbsp;&nbsp;&nbsp; 
                        </template>
                             &nbsp;&nbsp;&nbsp;&nbsp; 
                        <w-icon tile @click="show(item)">fal fa-eye</w-icon>

                    </w-flex>
                </template>
            </z-table>

            
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_utiliti+'kod_akaun',
        reload: true,
        tabs: [
          { title: 'Jejak Audit', content: '' },
      ],
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Utiliti', route: '/utiliti' },
            { label: 'Kod Akaun', route: '/utiliti/kod_akaun' }
          ],
           cari : { keterangan: '', kod: '', lkp_jenis_akaun_id: '', status: ''}
        }
         
  },
  methods: {
    add(akaun) {
            this.form = {
                id : null,
                lkp_jenis_akaun_id : null,
                // profil_id : null,
                akaun_id : null,
                kod : null,
                keterangan : null,
                akaun_asas : null,
                aras_akhir : null,
                status : null,
                akaun : akaun,
            }
            this.dialog.show = true
            this.form.saveButton = "Simpan"
        },
        show(idx) {
            this.form = idx
            this.modal.show = true
        },

         search() {
             this.$inertia.visit(window.route('utiliti.kod_akaun.index')+'?kod='+this.cari.kod+'&lkp_jenis_akaun_id='+this.cari.lkp_jenis_akaun_id+'&keterangan='+this.cari.keterangan+'&status='+this.cari.status , {preserveScroll:true})
            
        },
        reset(){
              this.cari = {keterangan: '', kod: '', lkp_jenis_akaun_id: '', status: ''}
              this.search()
        },
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 900
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>